<template>
  <div>
    Sobald andere Geräte, die sich im selben (W)LAN-Netztwerk befinden,
    XidrasTransfer öffnen, kannst du diese rund um dich sehen.
  </div>
</template>

<script>
  import Vue from 'vue';
  import {switchRoom} from './step-utils';


  const component = {
    name: 'StepPeerDescription'
  };


  export const StepPeerDescription = {
    before: async () => {
      await switchRoom('local');
      Vue.store.commit('share/updateTour', {examplePeer: true});
    },
    after: () => Vue.store.commit('share/updateTour', {examplePeer: false}),
    target: '[peer-id="example"]',
    header: 'Andere Geräte im <strong>selben</strong> Netztwerk',
    content: component
  };


  export default component;
</script>
